<template>
  <div class="form__radio">
    <input
      :id="id"
      :name="name"
      type="radio"
      class="form__radio-input"
      @click="$emit('selected', field, value)">
    <label
      :for="id"
      :value="label"
      class="form__radio-label"
    >{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: "FieldRadio",
  props: {
    field: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    name: {
      required: true,
      type: String
    },
    value: {
      type: String,
      required: true
    }
  }
};
</script>
